import styled from 'styled-components';

const CircleOfFifthsStyle = styled.div`
   h1,
   h2 {
      font-family: var(--heading-font);
      letter-spacing: 0.025em;
      line-height: 1.42;
      font-weight: normal;
   }

   h1 {
      font-size: 1.75em;
   }

   @media (min-width: 450px) {
      h1 {
         font-size: 2em;
      }
   }

   h2 {
      font-size: 1.5em;
   }

   em {
      font-style: italic;
   }

   strong {
      font-weight: bold;
   }

   a {
      color: var(--brand-darker-green);
      text-decoration: underline;
   }

   a:hover,
   a:focus-visible {
      text-decoration: none;
   }

   @media (prefers-color-scheme: dark) {
      a {
         color: #ff6912;
      }
   }

   button {
      outline: none;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
      color: var(--text-color);
      border: 2px solid;
      border-radius: 0.25em;
      padding: 0.25em 0.5em;
      font-size: inherit;
      text-align: center;

      :disabled {
         cursor: not-allowed;
         opacity: 0.3;
      }

      &:focus-visible,
      &:active,
      &:hover {
         :not(:disabled) {
            color: var(--hover-color);
         }
      }
   }

   @media (prefers-color-scheme: light) {
      button {
         &:hover:not(:disabled),
         &:focus-visible:not(:disabled),
         &:active:not(:disabled) {
            background-color: var(--hover-color);
            color: var(--hover-text-color);
            border-color: var(--brand-darker-orange);
         }
      }
   }

   select {
      appearance: none;
      background-color: var(--background-color);
      border: none;
      padding: 0;
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      cursor: inherit;
      line-height: inherit;
      color: var(--text-color);
      outline: none;

      border: 2px solid;
      border-radius: 0.25em;
      padding: 0.25em 1.5em 0.25em 0.5em;
      cursor: pointer;
      background-image: url("data:image/svg+xml;utf8,<svg stroke='%23006061' fill='none' stroke-width='2' viewBox='0 0 24 24' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='6 9 12 15 18 9'></polyline></svg>");
      background-size: 1.25em;
      background-position: right 3px center;
      background-repeat: no-repeat;

      &:hover,
      &:focus,
      &:active {
         color: var(--hover-color);
         border-color: var(--hover-color);
         background-image: url("data:image/svg+xml;utf8,<svg stroke='%23ff6912' fill='none' stroke-width='2' viewBox='0 0 24 24' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='6 9 12 15 18 9'></polyline></svg>");
      }
   }

   @media (prefers-color-scheme: dark) {
      select {
         background-image: url("data:image/svg+xml;utf8,<svg stroke='%2380bfbf' fill='none' stroke-width='2' viewBox='0 0 24 24' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='6 9 12 15 18 9'></polyline></svg>");
      }
   }

   @media (prefers-color-scheme: light) {
      select:not(.cof-key-select) {
         &:hover,
         &:focus,
         &:active {
            background-color: var(--hover-color);
            color: var(--hover-text-color);
            border-color: var(--brand-darker-orange);
            background-image: url("data:image/svg+xml;utf8,<svg stroke='%23ffffff' fill='none' stroke-width='2' viewBox='0 0 24 24' stroke-linecap='round' stroke-linejoin='round' xmlns='http://www.w3.org/2000/svg'><polyline points='6 9 12 15 18 9'></polyline></svg>");
         }
      }
   }

   .cof-top-header {
      h1 {
         text-align: center;
         margin-top: 0.5em;
      }
   }

   .cof-side-header {
      header {
         display: none;
      }

      h1 {
         display: none;
         margin-top: 0.5em;
      }
   }

   @media (min-width: 700px) {
      .cof-top-header {
         h1 {
            display: none;
         }

         header {
            display: none;
         }
      }

      .cof-side-header {
         header {
            display: block;
            text-align: left;
         }

         h1 {
            display: block;
         }
      }
   }

   @media (min-width: 700px) and (min-height: 500px) {
      .cof-top-header {
         header {
            display: block;
         }
      }

      .cof-side-header {
         header {
            display: none;
         }

         h1 {
            margin-top: 0;
         }
      }
   }

   .cof-content-wrapper {
      max-width: 1200px;
      margin: 0 auto;
      padding: 25px;
   }

   .cof-content {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-family: var(--content-font);
      max-width: var(--visible-and-safe-height);
      margin: 0 auto;
      display: block;
   }

   .cof-circle-of-fifts {
      max-width: var(--visible-and-safe-height);
      margin: 0 auto;
      display: block;
   }

   @media (min-width: 700px) {
      .cof-content-wrapper {
         display: flex;
         align-items: flex-start;
         position: relative;
      }
      .cof-content {
         width: 40%;
         margin-left: 50px;
      }

      .cof-circle-of-fifts {
         width: 60%;
         position: sticky;
         top: var(--safe-area-inset-top);
         margin: 0 0 0 auto;
      }
   }

   @media (min-width: 700px) and (min-height: 700px) and (orientation: landscape) {
      .cof-content-wrapper {
         align-items: center;
      }
   }

   .cof-lead-magnet,
   .cof-transpose {
      margin-top: 2rem;
   }

   .cof-key-definitions {
      font-size: 1.25em;

      td {
         height: 2em;
         vertical-align: bottom;
      }
      td:last-child {
         padding-left: 1.5em;
         font-weight: bold;
      }

      .cof-key-is-selected tr:hover {
         color: var(--brand-light-orange);
      }
   }

   .cof-original-key {
      select {
         border: none;
         padding: 0;
         padding-right: 1.5em;
         font-weight: bold;
      }
   }

   .cof-lead-magnet p {
      font-size: 1.125em;
      margin-top: 0.5em;
      line-height: 1.4;
   }

   .cof-transpose form {
      margin-top: 0.75em;
      display: flex;
      flex-wrap: wrap;
   }

   .cof-drag-drop-wrapper {
      width: 100%;
   }

   .cof-drag-drop {
      text-align: center;
      cursor: pointer;
      display: block;
      border-radius: 15px;
      border: 2px dashed;
      padding: 20px;
      line-height: 1.4;

      svg {
         width: 100%;
      }
   }

   .cof-is-dragging,
   .cof-drag-drop:hover {
      color: var(--hover-color);
   }

   .cof-invalid-file {
      color: var(--semantic-error);
   }

   .cof-drag-drop-input {
      height: 0;
      width: 0;
      overflow: hidden;
   }

   .cof-fields {
      width: 100%;

      label {
         display: block;
         font-weight: bold;
         margin-bottom: 0.25em;
      }

      select,
      button {
         width: 100%;
      }

      button {
         margin-top: 1em;
      }
   }

   @media (min-width: 950px) {
      .cof-drag-drop-wrapper {
         width: 60%;
      }

      .cof-drag-drop {
         margin-right: 1.5em;
      }

      .cof-fields {
         width: auto;
      }
   }

   .cof-major,
   .cof-minor {
      font-size: 1.5em;
      font-weight: bold;
      font-family: var(--content-font);
      cursor: pointer;

      path {
         stroke: var(--text-color);
         stroke-width: 2;
         fill: var(--background-color);
         transition: fill 0.25s ease;
      }

      text {
         fill: var(--text-color);
      }

      tspan {
         baseline-shift: super;
         font-size: 0.6em;
         stroke-width: 1;
         stroke: var(--text-color);
      }

      &:hover {
         path {
            fill: var(--hover-color);
         }

         text,
         tspan {
            fill: var(--hover-text-color);
         }

         tspan {
            stroke: var(--hover-text-color);
         }
      }
   }

   .cof-selected,
   .cof-fourth,
   .cof-fifth,
   .cof-relative {
      path {
         fill: var(--brand-dark-green);
      }

      text,
      tspan {
         fill: var(--background-color);
      }

      tspan {
         stroke: var(--background-color);
      }
   }

   .cof-selected-highlighted .cof-selected path,
   .cof-fourth-highlighted .cof-fourth path,
   .cof-fifth-highlighted .cof-fifth path,
   .cof-relative-highlighted .cof-relative path {
      fill: var(--brand-light-orange);
   }

   .cof-fourth,
   .cof-fifth,
   .cof-relative {
      path {
         fill: var(--brand-green);
      }
   }

   @media (prefers-color-scheme: dark) {
      .cof-selected,
      .cof-fourth,
      .cof-fifth,
      .cof-relative {
         path {
            fill: var(--brand-light-green);
         }

         text,
         tspan {
            fill: var(--background-color);
         }

         tspan {
            stroke: var(--background-color);
         }
      }

      .cof-fourth,
      .cof-fifth,
      .cof-relative {
         path {
            fill: var(--brand-green);
         }
      }
   }

   .cof-inner-circle {
      stroke: var(--text-color);
      stroke-width: 2;
      fill: var(--background-color);
   }

   .cof-key-name sup {
      vertical-align: super;
      font-size: smaller;

      &.cof-flat {
         position: relative;
         left: -2px;
      }
   }
`;

export { CircleOfFifthsStyle };
